import { render, staticRenderFns } from "./DetectionModelRank.vue?vue&type=template&id=46e34ed8&"
import script from "./DetectionModelRank.script.js?vue&type=script&lang=js&"
export * from "./DetectionModelRank.script.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports